import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const salesDocService = {
  getAllSalesDocs,
  getAllSalesDocsAggregated,
  getSalesDoc,
  createSalesDoc,
  updateSalesDoc,
  deleteSalesDoc,
  getConsignmentInventory,
  getConsignmentBalance,
  generatePdf,
  convertSoToSi,
  getQuotationStatus,
  markQuotationWon,
  markQuotationLost,
  getCustomerPrice,
  selectQuotationOptions,
  getLastOrder,
  getDocPayment,
  recordDocPayment,
}

const API_URL = API.BASE_URL + '/v1'

export const DOC_TYPES = [
  'quotation',
  'salesorder',
  'deliveryorder',
  'salesinvoice',
  'cashsale',
  'creditnote',
  'debitnote',
  'deliveryreturn',
  'consignment',
]

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.debtorCode) params.debtor_code = filter.debtorCode
  if (filter?.dateFrom) params.date_from = filter.dateFrom
  if (filter?.dateTo) params.date_to = filter.dateTo
  filter?.searchArray?.forEach((w, i) => {
    if (w !== null && w !== '') params[`search_words[${i}]`] = w
  })
  return params
}

export function getAllSalesDocs(docType, filter) {
  return apiHelper(API_URL).get(`/sales/${docType}`, { params: buildParams(filter) })
}
export function getAllSalesDocsAggregated(filter) {
  return apiHelper(API_URL).get('/sales/all', { params: buildParams(filter) })
}
export function getSalesDoc(docType, docNo) {
  return apiHelper(API_URL).get(`/sales/${docType}/${docNo}`)
}
export function createSalesDoc(docType, data) {
  return apiHelper(API_URL).post(`/sales/${docType}`, data)
}
export function updateSalesDoc(docType, docNo, data) {
  return apiHelper(API_URL).put(`/sales/${docType}/${docNo}`, data)
}
export function deleteSalesDoc(docType, docNo) {
  return apiHelper(API_URL).delete(`/sales/${docType}/${docNo}`)
}
export function getConsignmentInventory(docNo) {
  return apiHelper(API_URL).get(`/sales/consignment/${docNo}/inventory`)
}
export function getConsignmentBalance(debtorCode) {
  return apiHelper(API_URL).get(`/sales/consignment/balance/${debtorCode}`)
}
export function generatePdf(docType, docNo) {
  return apiHelper(API_URL).get(`/sales/${docType}/${docNo}/pdf`, { responseType: 'blob' })
}
export function convertSoToSi(docNo) {
  return apiHelper(API_URL).post(`/sales/salesorder/${docNo}/convert-to-invoice`)
}
export function getQuotationStatus(docNo) {
  return apiHelper(API_URL).get(`/sales/quotation/${docNo}/status`)
}
export function markQuotationWon(docNo, data) {
  return apiHelper(API_URL).patch(`/sales/quotation/${docNo}/won`, data || {})
}
export function markQuotationLost(docNo, data) {
  return apiHelper(API_URL).patch(`/sales/quotation/${docNo}/lost`, data || {})
}
/** Agent-side pick of an alternative offer per item: {selections:[{item_code, option_uuid}]}. */
export function selectQuotationOptions(docNo, selections) {
  return apiHelper(API_URL).patch(`/sales/quotation/${docNo}/select-options`, { selections })
}
export function getCustomerPrice(data) {
  return apiHelper(API_URL).post('/sales/customer-price', data)
}
export function downloadSalesDocPdf(docType, docNo) {
  return apiHelper(API_URL).get(`/sales/${docType}/${docNo}/pdf`, { responseType: 'blob' })
}

/**
 * What this customer bought last time, to fill a new document's lines.
 *
 * `types` defaults on the server to cash sales and invoices — things the
 * customer actually bought. A quotation is not one of those: it may have been
 * declined, and reordering from a price nobody accepted turns a quoted discount
 * into a real one.
 */
export function getLastOrder(debtorCode, params = {}) {
  return apiHelper(API_URL).get(`/sales/last-order/${debtorCode}`, { params })
}

/** How a document was paid, if it has been recorded. */
export function getDocPayment(docType, docNo) {
  return apiHelper(API_URL).get(`/sales/${docType}/${docNo}/payment`)
}

/**
 * Record how a document was paid. Posted after the document exists — the ledger
 * issues the number, so there is nothing to attach a payment to until it has
 * answered. Paying by cash also credits the collecting agent's wallet.
 */
export function recordDocPayment(docType, docNo, data) {
  return apiHelper(API_URL).post(`/sales/${docType}/${docNo}/payment`, data)
}
